module.exports = __webpack_public_path__ + "world-expo-preview.png?ff1e1afcb1a56916b0466c81ece3539e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/world-expo-preview.png
// module id = 274
// module chunks = 0